module.exports = __webpack_public_path__ + "static/media/IN_Payslip_7.c9835eab.png";